import React, { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import "../styles/Policy.css";

import logo from "../assets/policy-logo.png";
import { toast } from "react-toastify";
import CONFIG from "../utils/config";
import { useLocation, useNavigate } from "react-router-dom";


const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const Policy = () => {
  const [loading, setLoading] = useState(false);
  const [renPolicyNumber, setRenPolicyNumber] = useState("");
  const [renProposalNumber, setRenProposalNumber] = useState("");
  const [makeModel, setMakeModel] = useState("");
  const [paymentValidated, setPaymentValidated] = useState(false);

  const [conversionFailed, setConversionFailed] = useState(false);
  const [alreadyConverted, setAlreadyConverted] = useState(false);
 const [polNumber,setPolNumber]=useState("")
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const transId = searchParams.get("transId");
  const statusId = Number(searchParams.get("statusId"));


  
  

  // Robust parsing for policy number and SGS ID
  let policyNumber = null;
  let sgsId = null;
  if (transId) {
    if (transId.includes("##")) {
      [policyNumber, sgsId] = transId.split("##");
    } else if (transId.includes("-")) {
      [policyNumber, sgsId] = transId.split("-");
    } else {
      policyNumber = transId;
    }
  }

  useEffect(() => {
    if (statusId === 2) {
      setPaymentValidated(true);
    } else {
      toast.error("Payment not successful. Redirecting...");
      navigate("/plan", {
        state: {
          id: sgsId,
        },
        replace: true,
      });
    }
  }, [statusId, navigate, sgsId]);
  

  console.log("🔍 Parsed policyNumber:", policyNumber, "SGS ID:", sgsId);

  useEffect(() => {
    if (!paymentValidated) return;
  
    if (!sgsId) {
      toast.error("SGS ID missing, cannot process renewal");
      return;
    }
  
    processRenewal(sgsId);
  }, [paymentValidated, sgsId]);
  

  const navigatePdf = (renProposalNumber) => {
    console.log("📥 navigatePdf called with:", renProposalNumber);
    if (!renProposalNumber) return;
  
  
    const formattedProposalNumber = renProposalNumber.replace(/\//g, "_");
    const pdfUrl = `${CONFIG.PDFDOWNLOAD}/download/download_policy_format/${formattedProposalNumber}`;
    console.log("➡ PDF URL:", pdfUrl);
   
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);
  };

  const onclickPdf = (renProposalNumber) => {
    if (!renProposalNumber) return;
  
    const formattedProposalNumber = renProposalNumber.replace(/\//g, "_");
    const pdfUrl = `${CONFIG.PDFDOWNLOAD}/download/download_policy_format/${formattedProposalNumber}`;
  
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `${formattedProposalNumber}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  
  // Example button
 
  const sendCompanyEmail = async (proposalNo) => {
    if (!proposalNo) return;
  
    try {
      console.log("🏢 Sending company email for proposal:", proposalNo);
  
      const response = await fetch(
        `${CONFIG.MAIL}/app/send_company_email`,
        {
          method: "GET", // ⬅ as per curl
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            proposal_no: proposalNo,
          }),
        }
      );
  
      const result = await response.json();
      console.log("✅ Company email sent:", result);
    } catch (error) {
      console.error("❌ Company email failed:", error);
    }
  };
  
  

  const processRenewal = async (id) => {
    setLoading(true);
    let policyData = {};
  
    // 1️⃣ Fetch policy data
    try {
      console.log("🚀 STEP 1: Fetching policy data (/getVehicleData)...");
      const res = await fetch(`${CONFIG.BASE}/insurance/getVehicleData`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(id) }),
      });
      policyData = await res.json();
      console.log("✅ STEP 1 Success: Policy data received:", policyData);
      setMakeModel(policyData.makeModel);
      if(policyData.renProposalNumber !== null){
        navigatePdf(policyData.renProposalNumber);
     }
     setRenProposalNumber(policyData.renProposalNumber)
      setPolNumber(policyData.renPolicyNumber)
      
    } catch (err) {
      console.error("❌ STEP 1 Failed (/getsgs):", err);
      toast.error("Failed to fetch policy data");
      setLoading(false);
      return;
    }
  
    await wait(500);
  
   
    let renPolicyNumberLocal = null;
    try {
      console.log("🚀 STEP : Converting renewal quote (/finalize-policy)...");
      // const url = new URL("${CONFIG.BASE}/insurance/finalize-policy");
      // url.searchParams.append("quotationNo", policyData.renProposalNumber);
      // url.searchParams.append("productCode", policyData.productCode);

      const url = `${CONFIG.BASE}/insurance/finalize-policy?productCode=${policyData.productCode}&quotationNo=${policyData.renProposalNumber}&loginId=${""}`;
 
      const convertRes = await fetch(url.toString(), { method: "POST", headers: { "Content-Type": "application/json" } });
      const convertData = await convertRes.json();
      console.log("✅ STEP  Response:", convertData);
      // if(convertData.policyNo !== null){
      //    downloadPdf(convertData.policyNo);
      // }
      if (convertData.errCode === 3) {
        setAlreadyConverted(true);
        setRenPolicyNumber(policyData.renPolNumber);
        toast.info("This policy is already renewed!");
      } else if (convertData.policyNo) {
        renPolicyNumberLocal = convertData.policyNo;
        setRenPolicyNumber(renPolicyNumberLocal);
        toast.success("Renewal converted successfully!");
      } else {
        throw new Error(convertData.errMsg || "Unknown error during conversion");
      }
    } catch (err) {
      console.error("❌ STEP  failed:", err);
      toast.error("Renewal conversion failed!");
      setConversionFailed(true);
      setLoading(false);
      return;
    }
  
    // await wait(500);
  
    // 3️⃣ Download PDF
    // try {
    //   if (polNumber) {
    //     console.log("🚀 STEP 3: Downloading PDF using renPolicyNumber...");
    
    //     const response = await fetch(
    //       `${CONFIG.BASE}/insurance/get-data-by-renewed-policy`,
    //       {
    //         method: "POST",
    //         headers: {
    //           "Content-Type": "application/json",
    //           Accept: "application/pdf",
    //         },
    //         body: JSON.stringify({ renPolicyNumber: polNumber }),
    //       }
    //     );
    
    //     if (response.ok) {
    //       const blob = await response.blob();
    //       const link = document.createElement("a");
    //       link.href = window.URL.createObjectURL(blob);
    //       link.download = `insurance_data_${polNumber.replace(/\//g, "_")}.pdf`;
    //       document.body.appendChild(link);
    //       link.click();
    //       document.body.removeChild(link);
    //       console.log("✅ STEP 3 Success: PDF downloaded!");
    //     } else {
    //       throw new Error("PDF download failed");
    //     }
    //   }
    // } catch (err) {
    //   console.error("❌ STEP 3 Failed (PDF):", err);
    // }
    
  
    await wait(500);
  
    // // 4️⃣ Send quotation email
    // try {
    //   console.log("🚀 STEP 4: Sending quotation email...");
    //   const emailData = {
    //     clientName: policyData.insuredName,
    //     make: `${policyData.vehMake} ${policyData.vehModel}`,
    //     year: policyData.manufacturingYear,
    //     premium: `${policyData.currency} ${new Intl.NumberFormat().format(policyData.premiumAmount)}`,
    //     recommendedOption: policyData.policyCovers,
    //     recipientEmail: policyData.email,
    //     senderName: policyData.senderName,
    //     senderTitle: policyData.senderTitle,
    //     senderPhone: policyData.mobileNumber,
    //     senderEmail: policyData.senderEmail || policyData.email,
    //     companyName: policyData.companyName,
    //     website: policyData.website,
    //     policyNumber: renPolicyNumberLocal,
    //   };
    //   console.log("📩 Email payload:", emailData);
  
    //   const formData = new FormData();
    //   console.log("Email data",formData)
    //   formData.append("data", new Blob([JSON.stringify(emailData)], { type: "application/json" }));
  
    //   await fetch(`${CONFIG.BASE}/email/send-quotation`, { method: "POST", body: formData });
    //   console.log("✅ STEP 4 Success: Quotation email sent!");
    //   toast.success("Email Sent Successfully!")
    //   await sendCompanyEmail(policyData.renProposalNumber);
    // } catch (err) {
    //   console.error("❌ STEP 4 Failed (email):", err);
    // }

 // ✅ Customer Renewal Email
try {
  console.log("🚀 Sending customer renewal email...");
  if (sgsId) {
    const customerKey = `customerEmailSent_${sgsId}`;

    if (!localStorage.getItem(customerKey)) {
      const res = await fetch(
        `${CONFIG.MAIL}/send-renewal-email/${sgsId}`,
        { method: "POST" } // No body needed, endpoint uses path param
      );
      console.log("✅ Customer renewal email triggered, status:", res.status);

      if (res.ok) {
        localStorage.setItem(customerKey, "true"); // mark as sent
        console.log(`📌 Customer email flag set for SGS ID: ${sgsId}`);
      }
    } else {
      console.log("⚠️ Customer email already sent, skipping...");
    }
  } else {
    console.warn("⚠️ Cannot send customer email, SGS ID is null");
  }
} catch (err) {
  console.error("❌ Failed to send customer renewal email:", err);
}

await wait(500);

// ✅ Company/Internal Renewal Email
try {
  console.log("🚀 Sending company/internal renewal notification...");
  if (sgsId) {
    const companyKey = `companyEmailSent_${sgsId}`;

    if (!localStorage.getItem(companyKey)) {
      const companyRes = await fetch(
        `${CONFIG.MAIL}/notify-renewal-success/${sgsId}`,
        { method: "POST" }
      );
      console.log("✅ Company/internal notification sent, status:", companyRes.status);

      if (companyRes.ok) {
        localStorage.setItem(companyKey, "true"); // mark as sent
        console.log(`📌 Company email flag set for SGS ID: ${sgsId}`);
      }
    } else {
      console.log("⚠️ Company/internal email already sent, skipping...");
    }
  }
} catch (err) {
  console.error("❌ Failed to send company/internal notification:", err);
}
    await wait(500);
    // 5️⃣ WhatsApp confirmation
    try {
      console.log("🚀 STEP 5: Sending WhatsApp confirmation...");
      await fetch(`${CONFIG.WHATSAPPURL}/whatsapp-policy/confirm`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mobileNumber: policyData.mobileNumber,
          name: policyData.insuredName,
          downloadLink: policyData.downloadLink || "",
          policyNumber: renPolicyNumberLocal,
        }),
      });
      console.log("✅ STEP 5 Success: WhatsApp confirmation sent!");
    } catch (err) {
      console.error("❌ STEP 5 Failed (WhatsApp):", err);
    }
  
    console.log("🏁 All steps executed in order!");
    setLoading(false);
  };
  

  return (
   <div className="policy-container">
  <div className="policy-card">
    <img src={logo} alt="Company Logo" className="logo" />

    <h3>
      {conversionFailed ? (
        " Sorry!"
      ) : (
        <>
          <FaCheckCircle className="success-icon" /> Thank you!
        </>
      )}
    </h3>

    <p>
      {conversionFailed
        ? "Renewal conversion failed, Please Contact Support Team."
        : "Your Policy has been processed successfully."}
    </p>

    {renPolicyNumber && (
      <p>
        <strong>Policy Number:</strong> {renPolicyNumber}
      </p>
    )}

    <div className="button-group">
      <a className="btn btn-primary" href="/">
        Home
      </a>

      {renProposalNumber && (
        <button
          className="btn btn-success ms-4"
          onClick={() => onclickPdf(renProposalNumber)}
        >
          Download Policy PDF
        </button>
      )}
    </div>
  </div>
</div>

  
  );
  
};

export default Policy;
